export const sortByProperty = (list, property) => {
    list.sort((aStore, bStore) => {
        if (aStore[property] < bStore[property]) {
            return -1
        }

        if (aStore[property] > bStore[property]) {
            return 1
        }
        return 0
    })
    return list
}



// WEBPACK FOOTER //
// ./src/util/sort.js